export default __webpack_public_path__ + "8c6a6a5e3d59704e22a5e4e7f5580d7e.svg";